<template>
  <BModal
    :model-value="modal"
    scrollable
    centered
    title="Extracharge"
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="">Extracharge</h5>
      </div>
      <BButton variant="link" class="close" @click="updateModal(false)">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <BForm>
      <div class="form-group">
        <BFormSelect
          v-model="extrachargeForm.extra_charge_category_uuid"
          :options="extrachargeCategories"
          text-field="name"
          value-field="uuid"
          class=""
        >
          <template #first>
            <BFormSelectOption :value="null" disabled
              >Select category</BFormSelectOption
            >
          </template>
          <BFormSelectOption
            v-if="
              extrachargeForm.extra_charge_category_uuid &&
              !extrachargeCategories.some(
                (c) => c.uuid === extrachargeForm.extra_charge_category_uuid
              )
            "
            :value="extrachargeForm.extra_charge_category_uuid"
            disabled
          >
            [Deleted Category]
          </BFormSelectOption>
        </BFormSelect>
      </div>
      <div class="form-group">
        <BFormInput placeholder="Name" v-model="extrachargeForm.name">
        </BFormInput>
      </div>
      <div class="form-group">
        <BFormInput
          placeholder="Price"
          type="number"
          v-model="extrachargeForm.price"
        >
        </BFormInput>
      </div>
      <!-- <div class="form-group">  
       <BFormInput placeholder="Quantity" type="number" v-model="extrachargeForm.quantity">
       </BFormInput>
      </div> -->
    </BForm>
    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton variant="primary" @click="handleAction" class="mr-2">{{
          extraChargeData && extraChargeData.uuid ? "Update" : "Save"
        }}</BButton>
        <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
      </div>
    </template>
  </BModal>
  <ToastResponse
    v-model="modalResponse.toast"
    :text="modalResponse.text"
    :success="modalResponse.success"
  />
</template>

<script>
import { ref, inject, onMounted, watch } from "vue";
import {
  BModal,
  BButton,
  BForm,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue-next";
import ToastResponse from "@/components/ToastResponse.vue";

export default {
  components: {
    BModal,
    BButton,
    BForm,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    ToastResponse,
  },
  emits: ["update:modal", "addOrUpdate"],
  props: {
    modal: Boolean,
    extraChargeData: Object,
  },
  setup(props, { emit }) {
    const repositories = inject("repositories");
    const extraChargeCategoryRepository = repositories
      ? repositories.extraChargeCategory
      : null;
    const extraChargeRepository = repositories
      ? repositories.extraCharges
      : null;
    const extrachargeCategories = ref([]);
    const extrachargeForm = ref({
      extra_charge_category_uuid: null,
      name: "",
      price: 0,
      quantity: 0,
    });

    const modalResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    const updateModal = (value) => {
      emit("update:modal", value); // Sync modal state with parent
    };

    const handleAction = () => {
      props.extraChargeData.uuid ? update() : create();
    };

    const create = async () => {
      const extrachargeFormValue = { ...extrachargeForm.value, quantity: 0 };
      await extraChargeRepository
        .create(extrachargeFormValue)
        .then(() => {
          updateModal(false);
          extrachargeForm.value = {};
          modalResponse.value = {
            toast: true,
            text: "Extra Charge created successfully",
            success: true,
          };
          emit("addOrUpdate");
        })
        .catch((err) => {
          console.error(err);
          Object.assign(modalResponse.value, {
            success: false,
            text: err.response.data.message,
            toast: true,
          });
        });
    };

    const update = async () => {
      console.log("Update UUID:", props.extraChargeData);

      await extraChargeRepository
        .update(
          props.extraChargeData.uuid || extrachargeForm.value.uuid,
          extrachargeForm.value
        )
        .then(() => {
          updateModal(false);
          // extrachargeForm.value = {};
          extrachargeForm.value = {
            extra_charge_category_uuid: null,
            name: "",
            price: 0,
            quantity: 0,
          };
          modalResponse.value = {
            toast: true,
            text: "Extra Charge updated successfully",
            success: true,
          };
          emit("addOrUpdate");
        })
        .catch((err) => {
          console.error(err);
          Object.assign(modalResponse.value, {
            success: false,
            text: err.response.data.message,
            toast: true,
          });
        });
    };

    const getListExtraChargeCategory = async (params) => {
      await extraChargeCategoryRepository
        .getAll(params)
        .then((res) => {
          const setOpt = res.data.data;
          extrachargeCategories.value = setOpt;

          console.log("ecCat", extrachargeCategories.value);
        })
        .catch((err) => {
          console.error(err);
        });
    };

    onMounted(async () => {
      getListExtraChargeCategory();
    });

    watch(
      () => props.extraChargeData,
      (newData) => {
        if (newData) {
          extrachargeForm.value = { ...newData };
        }
      },
      { immediate: true }
    );

    return {
      updateModal,
      handleAction,
      create,
      update,
      getListExtraChargeCategory,
      extrachargeCategories,
      extrachargeForm,
      modalResponse,
    };
  },
};
</script>

<style></style>
